<template>

</template>

<script>
export default {
  data() {
    return {
      tbSwitch: false
    }
  },
  methods: {
    switchChange() {
      this.$message.success("切换成功")
      // let ids = []
      // ids.push(1)
      // let params = new URLSearchParams()
      // params.append("ids", ids)
      // tbSwitch(params).then(response => {
      //   this.$message.success("切换成功")
      // })
    }
  }
}
</script>
